var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueRing751(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 210,
    viewBox: "0 0 209 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_153_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.841 158.173C108.326 160.91 97.2345 160.467 86.9707 156.9C76.7068 153.333 67.7311 146.803 61.1787 138.135C54.6262 129.467 50.7912 119.05 50.1587 108.203C49.5262 97.3552 52.1246 86.5637 57.6253 77.193C63.1259 67.8222 71.2818 60.293 81.0616 55.5574C90.8414 50.8219 101.806 49.0928 112.568 50.5887C123.331 52.0846 133.408 56.7383 141.526 63.9614C149.643 71.1846 155.437 80.6526 158.173 91.1683L105.005 105.005L118.841 158.173Z",
    fill: "#68C9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_153_44",
    x: 0.0655518,
    y: 0.0655212,
    width: 208.108,
    height: 209.878,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_153_44"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRing751);
export default __webpack_public_path__ + "static/media/blue-ring75-1.8cd3d47e7c1155caf5d12ccb9f24edf9.svg";
export { ForwardRef as ReactComponent };